import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/trademark-disputes/judicial-party/[judicialParty]/TrademarkDisputeJudicialPartyPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
